export type ComponentSettingsVariables = {
  id: string;
  display: string;
  category: string;
};
export const textVariables = {
  currentBreakpoint: [
    // { id: "unitName", display: "Unit name", category: "Discount" },
    // { id: "unit", display: "Unit", category: "Discount" },
    // { id: "rewardSnippet", display: "Reward snippet", category: "Discount" },
    { id: "discount", display: "Discount amount", category: "Discount" },
  ],
  nextBreakpoint: [
    { id: "quantity", display: "Amount remaining", category: "Discount" },
    // { id: "more", display: "More", category: "Discount" },
    // { id: "unitName", display: "Unit name", category: "Discount" },
    // { id: "rewardSnippet", display: "Reward snippet", category: "Discount" },
    { id: "discount", display: "Discount amount", category: "Discount" },
  ],
};

export const quantityButtonSettingsVariables = [
  {
    id: "discountSavedPercentage",
    display: "Saved percentage",
    category: "Discount",
  },
  {
    id: "discountSavedTotal",
    display: "Saved $ total",
    category: "Discount",
  },
  {
    id: "discountSavedPerItem",
    display: "Saved $ per item",
    category: "Discount",
  },
  { id: "productTitle", display: "Product title", category: "Product" },
  {
    id: "productNewTotalPrice",
    display: "New total price",
    category: "Product",
  },
  {
    id: "productNewPricePerItem",
    display: "New price per item",
    category: "Product",
  },
  {
    id: "productOriginalTotalPrice",
    display: "Original total price",
    category: "Product",
  },
  {
    id: "productOriginalPricePerItem",
    display: "Original price per item",
    category: "Product",
  },
  // { id: "custom_new_variable", display: "New variable", category: "Custom" },
];
